// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1ErUT","search":"Settings_search__3cDWK","filter":"Settings_filter__3436A"};